import { Room } from 'livekit-client';

export class RoomManager {
  private room: Room | null = null;

  constructor() {
    this.room = null;
  }

  get = () => {
    return this.room;
  };

  set = (room: Room) => {
    this.room = room;
  };

  reset = () => {
    this.room = null;
  };
}

export const roomInstance = new RoomManager();
